export enum EPaymentMethod {
  DAPP,
  TRANSFER,
  TTPAY,
  BALANCE,
}

export interface IPayType {
  icon: string
  name: string
  code: number
  codeEnum: number
  describe: string
  isShow: () => boolean
}
